/**
 * Free sample pack at £15 — the pure decisions, no DOM.
 *
 * The automatic discount "Free Sample Packs!" (Buy X get Y: spend £15, get 1 of the
 * 11 sample bundles 100% off, once per order) makes the pack free. This file only
 * decides WHICH pack the cart should hold and WHEN:
 *
 *   - qualifyingSubtotal: what the customer spent on real products (sample bundles
 *     never count towards their own threshold).
 *   - pickBundle: the pack that matches the cart best, using the same product-line
 *     rules as the customer-type analysis the bundles were built from.
 *   - plan: the one cart change to make next (add / remove / trim / nothing).
 *
 * Loaded by tests/free-sample.test.mjs as the real file; the DOM side lives in
 * assets/free-sample-cart.js.
 */
(function (root) {
  // product line -> sample bundle handle
  var BUNDLE_FOR = {
    colour_tech: 'fanola-sample-bundle-colour-salon',
    no_yellow: 'fanola-sample-bundle-blonde',
    no_orange: 'fanola-sample-bundle-brunette',
    no_red: 'fanola-sample-bundle-red',
    curly: 'fanola-sample-bundle-curly',
    styling: 'fanola-sample-bundle-stylist',
    repair: 'fanola-sample-bundle-dry-damaged',
    oro: 'fanola-sample-bundle-oro-therapy',
    colour_care: 'fanola-sample-bundle-colour-protection',
    everyday: 'fanola-sample-bundle-everyday'
  };
  var DISCOVERY = 'fanola-sample-bundle-salon-discovery';

  // Order matters: the first matching rule wins (mirrors the segmentation script).
  var RULES = [
    ['curly', /curl|curly/i],
    ['colour_tech', /fanola color |peroxide|activator|bleach|lightener|toner|color keratin|de-color|fiber fix|no yellow color|developer|glow (and|&) glossy|perm|neutrali|tinting|applicator/i],
    ['styling', /fantouch|styling tools/i],
    ['no_yellow', /no yellow/i],
    ['no_orange', /no orange/i],
    ['no_red', /no red/i],
    ['colour_care', /color locker|after colou?r/i],
    ['oro', /oro ?therapy/i],
    ['repair', /nourishing|botugen|keraterm|nutri/i],
    ['everyday', /volume|frequent|smooth|vitamin|energy|energizing|purif|balance|scalp|anti/i]
  ];

  function classify(title) {
    title = title || '';
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i][1].test(title)) return RULES[i][0];
    }
    return 'other';
  }

  function isSample(item, sampleVariantIds) {
    return sampleVariantIds.indexOf(Number(item.variant_id)) !== -1;
  }

  function isFree(item) {
    return !!(item.properties && item.properties._free_sample);
  }

  function linePrice(item) {
    return Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
  }

  function qualifyingSubtotal(items, sampleVariantIds) {
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (!isSample(items[i], sampleVariantIds)) total += linePrice(items[i]);
    }
    return total;
  }

  /**
   * The best pack for the cart: the product line with the most spend wins, unless no
   * line holds 40% of the spend (a mixed basket) - then Salon Discovery, as for the
   * "mixed backbar" customer type. Only available bundles are offered.
   */
  function pickBundle(items, bundles, sampleVariantIds) {
    var spend = {}, total = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (isSample(it, sampleVariantIds)) continue;
      var k = classify(it.product_title || it.title);
      var p = linePrice(it);
      spend[k] = (spend[k] || 0) + p;
      total += p;
    }
    var best = null, bestSpend = 0;
    for (var key in spend) {
      if (key !== 'other' && spend[key] > bestSpend) { best = key; bestSpend = spend[key]; }
    }
    var wanted = best && total > 0 && bestSpend / total >= 0.4 ? BUNDLE_FOR[best] : DISCOVERY;
    return firstAvailable([wanted, DISCOVERY], bundles);
  }

  function firstAvailable(handles, bundles) {
    for (var i = 0; i < handles.length; i++) {
      for (var j = 0; j < bundles.length; j++) {
        if (bundles[j].handle === handles[i] && bundles[j].available) return bundles[j];
      }
    }
    for (var b = 0; b < bundles.length; b++) if (bundles[b].available) return bundles[b];
    return null;
  }

  function byHandle(handle, bundles) {
    for (var i = 0; i < bundles.length; i++) if (bundles[i].handle === handle) return bundles[i];
    return null;
  }

  /**
   * The next cart change. One step at a time: the caller applies it, re-reads the
   * cart and asks again, so a cart in any state converges.
   *
   * state.declined  - the customer removed their free pack: never re-add on our own.
   * state.preferred - handle the customer picked with "Swap".
   */
  function plan(cart, cfg, state) {
    state = state || {};
    var items = cart.items || [];
    var ids = cfg.bundles.map(function (b) { return Number(b.variantId); });
    var free = items.filter(isFree);
    var q = qualifyingSubtotal(items, ids);

    if (q < cfg.threshold) {
      if (free.length) return { action: 'remove', key: free[0].key };
      return { action: 'none', qualifies: false, subtotal: q };
    }
    if (free.length > 1) return { action: 'remove', key: free[free.length - 1].key };
    if (free.length === 1) {
      if (free[0].quantity > 1) return { action: 'set', key: free[0].key, quantity: 1 };
      return { action: 'none', qualifies: true, subtotal: q };
    }
    if (state.declined) return { action: 'none', qualifies: true, declined: true, subtotal: q };
    var pref = state.preferred && byHandle(state.preferred, cfg.bundles);
    var pick = pref && pref.available ? pref : pickBundle(items, cfg.bundles, ids);
    if (!pick) return { action: 'none', qualifies: true, soldOut: true, subtotal: q };
    return { action: 'add', variantId: Number(pick.variantId), handle: pick.handle };
  }

  root.FreeSample = {
    classify: classify,
    qualifyingSubtotal: qualifyingSubtotal,
    pickBundle: pickBundle,
    plan: plan,
    BUNDLE_FOR: BUNDLE_FOR
  };
})(typeof window !== 'undefined' ? window : globalThis);
